import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ChevronLeft, LogOut } from 'lucide-react';
import logo from '../image/LOGKDO+.png';

const AdminNavbar = ({ title }) => {
    const navigate = useNavigate();

    return (
        <header className="bg-white border-b border-slate-200 sticky top-0 z-50">
            <div className="container mx-auto px-4 h-16 flex items-center justify-between">
                <div className="flex items-center gap-4">
                    <button
                        onClick={() => navigate('/')}
                        className="p-2 hover:bg-slate-100 rounded-full transition-colors text-slate-500"
                        title="Retour au menu"
                    >
                        <ChevronLeft size={20} />
                    </button>
                    <div className="h-8 w-px bg-slate-200 mx-1 hidden md:block"></div>
                    <img src={logo} alt="Logo" className="h-6 md:h-7 w-auto" />
                </div>

                <div className="absolute left-1/2 -translate-x-1/2 hidden md:block">
                    <h1 className="text-sm font-black text-slate-800 uppercase tracking-widest">{title}</h1>
                </div>

                <div className="flex items-center gap-3">
                    <button
                        onClick={() => {
                            localStorage.removeItem('token');
                            window.location.href = '/Login';
                        }}
                        className="flex items-center gap-2 px-3 py-1.5 bg-red-50 text-red-600 rounded-lg text-xs font-bold hover:bg-red-100 transition-colors"
                    >
                        <LogOut size={14} />
                        <span className="hidden sm:inline">Déconnexion</span>
                    </button>
                </div>
            </div>
        </header>
    );
};

export default AdminNavbar;
